<section class="nopad">
    <div class="container-fluid register">
        <div class="row">
            <div class="col-md-3 register-left">
                <div class="col-md-12 nopad">
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/AICTELogo.png" alt="Logo" style="margin-left: 25px;"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="height: 47px; margin-left: -20px;"></a>
                </div>
                <div class="col-md-12 nopad leftSection">
                    <img class="IconImg" src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
                    <h3>Welcome</h3>
                    <p>Login to start exploring the Student Learning Assessment Program</p>
                    <!-- <p>New user? Register Here</p>
                    <a [routerLink]="['/register']" class="mt-3 registerBtn loginBtn">REGISTER</a> -->
                </div>
            </div>
            <div class="col-md-9 register-right">
                <div class="col-md-12 nopad registerFormContainer">
                    <div class="col-md-6 nopad floatLeft flexOrder2">
                        <h2 class="registerHeadings">General Information</h2>
                        <mat-list>
                            <mat-list-item>1. Kindly login with your given username and password.</mat-list-item>
                            <mat-list-item>2. Do not share your credential details like password with anyone.</mat-list-item>
                            <mat-list-item>3. Click here to go back to&nbsp;<a href="../">home</a> &nbsp;page.</mat-list-item>
                            <mat-list-item>4. <span style="color: red; font-weight: 550;">IMPORTANT: </span>Please raise grievance in <a href="https://css.aicte-india.org/">https://css.aicte-india.org/</a>, if OTP is not received on registered email or mobile number.</mat-list-item>
                        </mat-list>
                    </div>
                    <div class="col-md-6 floatLeft leftBorder flexOrder1">
                        <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" autocomplete="off">
                            <h2 class="registerHeading">Login</h2>
                            <div class="nopad">
                                <mat-form-field [floatLabel]="'never'" class="w-100">
                                    <mat-label>Login As</mat-label>
                                    <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">person</mat-icon>
                                    <mat-select formControlName="login_as" required>
                                        <!-- <mat-option>Select</mat-option> -->
                                        <mat-option value="3">Expert</mat-option>
                                        <mat-option value="4">Reviewer</mat-option>
                                        <mat-option value="5">Institute</mat-option>
                                        <mat-option value="6">Student</mat-option>
                                        <mat-option value="8">Faculty</mat-option>
                                        <!-- <mat-option value="7">Head of Department</mat-option> -->
                                        <mat-option value="9">Finance</mat-option>
                                        <!-- <mat-option value="10">Nodal Officer</mat-option> -->
                                        <mat-option value="11">Consultant</mat-option>
                                        <mat-option value="1">Admin</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="form.controls.login_as.errors?.required">Login As is required</mat-error>
                                </mat-form-field>


                                <mat-form-field [floatLabel]="'never'" class="w-100">
                                    <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">mail</mat-icon>
                                    <input matInput placeholder="Email" formControlName="email" required maxlength="60" autocomplete="new-password">
                                    <!-- <mat-error *ngIf="form.controls.email.errors?.required">Email is required</mat-error> -->
                                    <mat-error *ngIf="form.controls.email.hasError('invalidEmail')">Invalid email address
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field [floatLabel]="'never'" class="w-100">
                                    <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">lock</mat-icon>
                                    <input matInput placeholder="Password" type="password" formControlName="password" maxlength="30" autocomplete="new-password">
                                    <!-- <mat-error *ngIf="form.controls.password.errors?.required">Password is required</mat-error> -->
                                </mat-form-field>

                                <div class="captchaContainerBorder">
                                    <div class="captchaContainer">
                                        <canvas #canvas2 id='canvas2' style="width: 50%; height: 96%;background: rgb(216, 215, 215);">captcha text</canvas>
                                        <input class="captchaInput" id="textBox" type="text" name="text" (input)="change(input.value)" #input formControlName="captcha" maxlength="8">
                                        <a style="cursor: pointer; margin-top: 5%;" (click)="refreshCaptcha()">
                                            <mat-icon>autorenew</mat-icon>
                                        </a>
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button class="btn w-100 mt-3 LoginBtn" type="submit" [disabled]="form.invalid">SIGN IN</button>
                                    <a routerLink="/request-password-reset">Forgot
                                      Password?</a>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="center">
        <h1 id="captchaHeading">Captcha Validator Using HTML, CSS and JavaScript</h1>
        <div id="captchaBackground">
        <canvas #canvas2 id='canvas2' style=" background-color: rgb(216, 211, 202);">captcha text</canvas>
        <input id="textBox" type="text" name="text">
        <div id="buttons">
        <input id="submitButton" type="submit">
        <button id="refreshButton" (click)="refresh()" type="submit">Refresh</button>
        </div>
        <span id="output"></span>
        </div>
        </div> -->
</section>